const api_config = {
   BASE_BACKEND_ENDPOINT: process.env.NODE_ENV === "production" ? 'https://sayify.pro/' : 'http://localhost:9000/',
   BASE_WS_ENDPOINT: 'wss://sayify.pro/', //process.env.NODE_ENV === "production" ? 'wss://sayify.pro/' : 'ws://localhost:9000/',
   ABORT_CONTROLLER: new AbortController(),
};

export default api_config; 